import { render, staticRenderFns } from "./ModalFilter.vue?vue&type=template&id=2b840126&"
import script from "./ModalFilter.vue?vue&type=script&lang=js&"
export * from "./ModalFilter.vue?vue&type=script&lang=js&"
import style0 from "./ModalFilter.vue?vue&type=style&index=0&id=2b840126&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports